module.exports = __webpack_public_path__ + "img/header-user.9ed762cf.png";